import moment from 'moment';
import SA from '../actions/redirectActions';
const init = {
    loading: '',
    success: null,
    error: null,
    redirectUrl: ''
};

export default (state=init, action) => {
    switch(action.type) {
        case SA.PENDING_REDIRECT_REQUEST:
            return {...state, loading: true, success:false, redirectUrl: null, };

        case SA.SUCCESS_REDIRECT_REQUEST:
            return {...state, loading: false, success: true, redirectUrl: action.payload.url };

        case SA.FAILURE_REDIRECT_REQUEST:
            return {...state, loading: false, success: false, error: action.payload };


        default: return {...state}
    }
}
